import React from 'react';
import clsx from 'clsx';
import { Warning } from '@phosphor-icons/react';
import { Checkbox } from 'src/components/Checkbox';

export interface WarningPanelProps {
  show: boolean;
  title: string;
  children: React.ReactNode;
  acknowledgement?: {
    checked: boolean;
    onChange: (checked: boolean) => void;
    label: string;
    id?: string;
  };
  icon?: React.ReactNode;
  className?: string;
}

export const WarningPanel: React.FC<WarningPanelProps> = ({
  show,
  title,
  children,
  acknowledgement,
  icon,
  className = '',
}) => {
  if (!show) return null;
  const checkboxId = acknowledgement?.id || 'warningAcknowledgment';

  return (
    <div
      className={clsx(
        'bg-error-100 border border-error rounded-lg p-4',
        className,
      )}
    >
      <div className="flex items-start space-x-3">
        <div className="flex-shrink-0 mt-0.5">
          {icon || <Warning size={24} className="text-error-600" />}
        </div>
        <div className="flex-1">
          <h4 className="text-sm font-bold text-error-600 mb-2">{title}</h4>
          <div className="text-sm text-error-600 leading-relaxed">
            {children}
          </div>
        </div>
      </div>
      {acknowledgement && (
        <div className="flex items-center space-x-2 ml-6 mt-4">
          <Checkbox
            checked={acknowledgement.checked}
            onChange={acknowledgement.onChange}
            ariaLabel={acknowledgement.label}
          />
          <label
            htmlFor={checkboxId}
            className="text-sm font-medium text-error-600"
          >
            {acknowledgement.label}
          </label>
        </div>
      )}
    </div>
  );
};
